export { default } from './truncated-text-with-auto-tooltip';
export type { TruncatedTextWithAutoTooltipProps } from './types';
